import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';
import { convertLocalEpochToUTC } from '../../util/timezone';

export const fetchInvestigatorWorkload = async ({ dashboardFilter }) => {
  const params = dashboardFilter
    ? {
        from: convertLocalEpochToUTC(dashboardFilter.from),
        to: convertLocalEpochToUTC(dashboardFilter.to)
      }
    : null;

  const response = await axios.get(`${CM_BASE_URL}/cases/workloads`, {
    params
  });

  if (response.status !== 200) {
    throw { message: 'Failed to fetch investigator workload' };
  }

  return response.data;
};
